import styled from "styled-components"
import Colors from "../../theme/colors"

const mapTypeToProps = ({ type }) => {
  switch (type) {
    case "primary":
      return `
          background: ${Colors.primaryGreen};
          color: ${Colors.white}
          border: 1px solid ${Colors.primaryGreen}
          &:hover {
            background: ${Colors.lightGreen}
            box-shadow: inset 0px -4px 4px rgba(22, 22, 22, 0.15), inset 0px 4px 1px rgba(255, 255, 255, 0.4);
          }
        `
    default:
      return `
      background: ${Colors.primaryGreen};
      color: ${Colors.white}
      border: 1px solid ${Colors.primaryGreen}
      &:hover {
        background: ${Colors.lightGreen}
        box-shadow: inset 0px -4px 4px rgba(22, 22, 22, 0.15), inset 0px 4px 1px rgba(255, 255, 255, 0.4);
      }
      `
  }
}

const Button: any = styled.button`
  font-family: Avenir Medium;
  width: 100%;
  min-width: 44px;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 10px;
  display: block;
  cursor: pointer;
  position: relative;
  transition: 100ms linear;
  ${mapTypeToProps};
  &[disabled] {
    opacity: 0.4;
    cursor: no-drop;
  }
`
export default Button



// WEBPACK FOOTER //
// ./src/components/button/button.component.tsx